const mappings = {
  '3840x2160': '4K',
  '2560x1440': '1440p',
  '1920x1080': '1080p',
  '1280x720': '720p',
  '854x480': '480p',
  '640x360': '360p',
  '426x240': '240p'
};

export const mapResolution = (width: number, height: number): string => {
  const key = `${width}x${height}`;

  if (mappings[key as keyof typeof mappings]) {
    return mappings[key as keyof typeof mappings];
  } else {
    return key;
  }
};
